import Vue from "vue";
import Vuex from "vuex";

import registration from "./modules/registration";
import organisation from "./modules/organisation";
import naics from "./modules/naics";
import jobseeker from "./modules/jobseeker";
import sga from "./modules/sga";
import agency from "./modules/agency";
import apprentice from "./modules/apprentice";
import account from "./modules/account";
import common from "./modules/common";
import notification from "./modules/notification";
import onlineprofile from "./modules/onlineprofile";
import skillspassport from "./modules/skillspassport";
import onet from "./modules/onet";
import wioa from "./modules/wioa";


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    registration,
    organisation,
    naics,
    jobseeker,
    sga,
    agency,
    apprentice,
    account,
    common,
    notification,
    onlineprofile,
    skillspassport,
    onet,
    wioa
  },
});
